export default __webpack_public_path__ + "static/team_newbg_mobile-ddaaee8d32298a0159f5bcc9153ff6b1.jpg";